import {getReportParams, report} from '../../../middleware/report';

//DWH => report 
export function popupReport(dwhDetails) {
  let reportParams = getReportParams();
  reportParams.area = dwhDetails.area;
  reportParams.subArea = dwhDetails.subArea;
  reportParams.channel = dwhDetails.channel;
  reportParams.status = dwhDetails.status;
  reportParams.customerName = dwhDetails.customerName;
  reportParams.subscriber = dwhDetails.subscriber;
  reportParams.idNumber = dwhDetails.contactId;
  reportParams.actionType = dwhDetails.actionType;
  reportParams.messageText = dwhDetails.messageText;
  reportParams.param1 = dwhDetails.param1;
  reportParams.param2 = dwhDetails.param2;
  reportParams.param3 = dwhDetails.param3;
  reportParams.param4 = dwhDetails.param4;

  report(reportParams);
}

